module.exports = __webpack_public_path__ + "img/5.4195f331.jpg";